import React from 'react'

import Table from '../../../../components/molecules/Table'

import { toTitleCase } from '../../../../utilities'
import { columnHelper, getDate, getFrequency } from './helpers'
import { useSubscription } from '../../../../providers/SubscriptionProvider'
import useStyles from './styles'

const SubscriptionSettings = () => {
  const { subscriptions, loaded } = useSubscription()

  const classes = useStyles()

  const columns = React.useMemo(() => {
    const name = columnHelper.accessor('name', {
      header: 'Name',
      cell: ({ row }) => <div className={classes.name}>{row.original.name}</div>
    })

    const frequency = columnHelper.accessor('interval', {
      header: 'Frequency',
      cell: ({ row }) => <div>{getFrequency(row.original)}</div>
    })

    const status = columnHelper.accessor('status', {
      header: 'Status',
      cell: ({ row }) => (
        <div className={classes.status}>{toTitleCase(row.original.status)}</div>
      )
    })

    const date = columnHelper.accessor('trial_end', {
      header: 'Info',
      cell: ({ row }) => (
        <div className={classes.date}>{getDate(row.original)}</div>
      )
    })

    return [name, frequency, status, date]
  }, [classes])

  return (
    <Table
      data={subscriptions}
      columns={columns}
      loaded={loaded}
      message='No subscriptions'
      hideCount
      disablePagination
    />
  )
}

export default SubscriptionSettings
